import React from "react";
import ReactDOM from "react-dom";
// import Handlebars from "handlebars";
const { data } = require('./Hero.data');

import "./Hero.scss";

// const htmlContent = require("./Hero.html");
import htmlContent from './Hero.hbs';// works as template fn

// const template = Handlebars.compile(htmlContent);// fails

const Hero = (props) => {

  const {
    // data
  } = props;

  const h_cont = htmlContent(data);

  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: h_cont}} className={`hbs_comp plax-bg`} />
      {/* <div dangerouslySetInnerHTML={{ __html: template(data) }} /> */}
    </>
  );
}

export default Hero
